var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bk-content"},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"allowfullscreen":"true","frameborder":"no","src":_vm.iframeUrl + '&t=' + Math.random()}})])
}
var staticRenderFns = []

export { render, staticRenderFns }